import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import Backdrop from '@material-ui/core/Backdrop'
import CircularProgress from '@material-ui/core/CircularProgress'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 9999,
    color: '#fff',
  },
}))

const LoaderOverlay = (props) => {
  const { open } = props
  const [isOpened, setIsOpened] = useState(open)
  const classes = useStyles()

  useEffect(() => {
    setIsOpened(open)
  }, [open])

  return (
    <div>
      <Backdrop className={classes.backdrop} open={isOpened}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  )
}

LoaderOverlay.propTypes = {
  open: PropTypes.bool,
}
LoaderOverlay.defaultProps = {
  open: false,
}

export default LoaderOverlay
